import { API_endpoints } from "../config";

export const deleteCost = async (id: string) => {
    try {
        const response = await fetch(API_endpoints.deleteCost, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json",
            },
            credentials: "include",
            body: JSON.stringify({ id }),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw new Error(errorData.message || "Fehler beim Löschung von Tarif Daten.");
        }

        const responseData = await response.json();
        return responseData;
    } catch (error) {
        console.error("Fehler beim Löschung von Tarif Daten:", error);
        throw error;
    }
};
